import ApiClient from '../ApiClient';

class AccountTemplatesAPI extends ApiClient {
  constructor() {
    super('super_admin/account_templates', { apiVersion: 'v1' });
  }
}

export default new AccountTemplatesAPI();
